import { render, staticRenderFns } from "./CoverImg.vue?vue&type=template&id=1fff4614&scoped=true&"
import script from "./CoverImg.vue?vue&type=script&lang=js&"
export * from "./CoverImg.vue?vue&type=script&lang=js&"
import style0 from "./CoverImg.vue?vue&type=style&index=0&id=1fff4614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff4614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fff4614')) {
      api.createRecord('1fff4614', component.options)
    } else {
      api.reload('1fff4614', component.options)
    }
    module.hot.accept("./CoverImg.vue?vue&type=template&id=1fff4614&scoped=true&", function () {
      api.rerender('1fff4614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/a-kit/CoverImg.vue"
export default component.exports